export const stockData = [
  {
    "stockSymbol": "RELIANCE",
    "quantity": 50,
    "buyPrice": 2500.75,
    "sellPrice": 2550.25,
  },
  {
    "stockSymbol": "TATASTEEL",
    "quantity": 30,
    "buyPrice": 1200.50,
    "sellPrice": 1225.75,
  },
  {
    "stockSymbol": "WIPRO",
    "quantity": 15,
    "buyPrice": 350.20,
    "sellPrice": 320.75,
  },
  {
    "stockSymbol": "HDFCBANK",
    "quantity": 40,
    "buyPrice": 1400.25,
    "sellPrice": 1450.50,
  },
  {
    "stockSymbol": "INFY",
    "quantity": 60,
    "buyPrice": 1500.30,
    "sellPrice": 1550.75,
  },
  {
    "stockSymbol": "ITC",
    "quantity": 25,
    "buyPrice": 200.60,
    "sellPrice": 210.25,
  },
  {
    "stockSymbol": "ONGC",
    "quantity": 20,
    "buyPrice": 120.40,
    "sellPrice": 110.75,
  },
  {
    "stockSymbol": "COALINDIA",
    "quantity": 35,
    "buyPrice": 150.90,
    "sellPrice": 140.25,
  },
  {
    "stockSymbol": "SBIN",
    "quantity": 45,
    "buyPrice": 250.80,
    "sellPrice": 230.25,
  },
  {
    "stockSymbol": "CIPLA",
    "quantity": 30,
    "buyPrice": 700.60,
    "sellPrice": 680.25,
  }
];

export const assetsData = [
  { type: "Fixed Deposits (FDs)", amount: 50000, cagr: 8, year: 2022, currentValue: 0 },
  { type: "Equities (Stocks)", amount: 100000, cagr: 5, year: 2022, currentValue: 0 },
  { type: "Savings Account", amount: 20000, cagr: 2, year: 2022, currentValue: 0 },
  { type: "Gold", amount: 3000, cagr: 3, year: 2022, currentValue: 0 },
];

export const liabilitiesData = [
  { type: "Home Loan", amount: 200000, interestRate: 4, tenure: 20, monthlyInstallement: 1500, year: 2022, currentValue: 0 },
  { type: "Car Loan", amount: 30000, interestRate: 6, tenure: 5, monthlyInstallement: 500, year: 2022, currentValue: 0 },
  { type: "Student Loan", amount: 15000, interestRate: 3, tenure: 10, monthlyInstallement: 200, year: 2022, currentValue: 0 },
  { type: "Credit Card Debt", amount: 5000, interestRate: 18, tenure: 1, monthlyInstallement: 500, year: 2022, currentValue: 0 }
];
